import { render, staticRenderFns } from "./Kdm.vue?vue&type=template&id=d2ec57f6&lang=pug"
import script from "./Kdm.vue?vue&type=script&lang=js"
export * from "./Kdm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports